<template>
    <div id="container">
        <div class="backstep" @click="startReturn">
            <i class="fas fa-long-arrow-alt-left"></i>
        </div>
        <div class="error-msg">
            <h2><i class="fas fa-exclamation-circle"></i>{{trad.pageMail.errorMail}}</h2>
        </div>
        <h2>{{trad.pageMail.titleMail}}</h2>
        <input @click="hideMsg" class="mailInput" type="mail" required v-model="mail">
        <br>
        <button @click="mailChecked">{{trad.pageMail.button}}</button>
        <br>
        <img :src="help[randPic]" alt="Help-pic">
        <div class="help-container">
            <div class="talk-bubble tri-right round btm-left">
                <div class="talktext">
                    <p>{{trad.pageMail.help}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: "WelcomeMailCheck",
    data() {
        return {
            mail: '',
            checked: false,
            trad: this.langTxt,
            help: ["help0.png","help1.png","help2.png","help3.png","help4.png"]
        }
    },
    props: ["demoProgression", "randPic","langTxt"],
    created: function() {
            window.scrollTo(0,document.body.scrollHeight);
            
            if(localStorage['mail']) {
                this.mail = localStorage['mail']
            }
            else {
                return false
            }
    },
    methods: {
        isEmailValid() {
            let reg = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/

            return (this.mail == "")? "" : (reg.test(this.mail)) ? true : false;
        },
        mailChecked(e) {
            if(this.isEmailValid())
            {
            e.preventDefault();

            this.checked = true;
            this.demoProgression[0].mail = this.mail;
            this.demoProgression[0].completedMail = this.checked;

            // Progression bar
            this.$emit('mail-checked', this.demoProgression);

            // Stock in local browser
            localStorage.setItem('mail', this.mail);
            }
            else
            {
                let errorMsg = document.querySelector(".error-msg")
                errorMsg.classList.add("error-show");
            }
        },
        hideMsg() {
            let errorMsg = document.querySelector(".error-msg")
                errorMsg.classList.remove("error-show");
        },
         startReturn() {
                this.demoProgression[0].demoStart = false;
                this.demoProgression[0].completedMail = false;
                this.demoProgression[0].completedName = false;
                this.demoProgression[0].completedPhone = false;
                this.demoProgression[0].sendClicked = false;
                this.demoProgression[0].preview = false;
        }
    }
}
</script>

<style scoped>
    #container {
        padding: 50px;
        padding-top: 35px;
        box-shadow: 10px 10px 20px 0px rgba(133,133,133,0.55);
        margin: auto;
        width: fit-content;
        height: 480px;
        margin-top: 15px;
        border-radius: 10px;
        position: relative;
    }
    input[type="mail"] {
    -webkit-appearance: none;
    }
    .mailInput {
        border-radius: 10px;
        border: none;
        width: 375px;
        height: 40px;
        box-shadow:#e6e6e6 4px 4px 8px;
        background-color: #fafafa;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        color: rgb(59, 59, 59);
    }
    button {
        padding: 8px;
        background-color: #3F608E;
        color: white;
        font-size: 20px;
        font-weight: bold;
        border-radius: 10px;
        margin-top: 45px;
        cursor: pointer;
        border: none;
        z-index: 9999;
        font-family: Avenir, Helvetica, Arial, sans-serif;
    }
    button:hover {
        transition-duration: 0.8s;
        background: #7C9048;
    }
    h2 {
        margin: 25px;
        margin-top: 35px;
    }

    /* Start Error Message */

    .error-msg {
        display: none;
    }
    .error-show {
        display: flex !important;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        position: absolute;
        top: 37%;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        color: #a7a7a7;
        
        height: fit-content;
    }
    .error-show h2{
        padding: 0;
        margin: 0;
    }

    /* End Error Message */

    /* Start Help User */

    .help-container {
        position: absolute;
        width: fit-content;
        height: fit-content;
        bottom: 95px;
        left: 90px;
    }
    img {
        width: 125px;
        position: absolute;
        left: -5px;
        bottom: -15px;
    }
    .talk-bubble {
        display: inline-block;
        position: relative;
        width: 300px;
        height: auto;
        background-color: #f9f9db;
    }
    .border{
        border: 8px solid #666;
    }
    .round{
        border-radius: 30px;
        -webkit-border-radius: 30px;
        -moz-border-radius: 30px;
    }
    .tri-right.border.btm-left:before {
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        left: -8px;
        right: auto;
        top: auto;
        bottom: -40px;
        border: 32px solid;
        border-color: transparent transparent transparent #666;
    }
    .tri-right.btm-left:after{
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        left: 0px;
        right: auto;
        top: auto;
        bottom: -20px;
        border: 22px solid;
        border-color: transparent transparent transparent #f9f9db;
    }
    .talktext{
        padding: 1em;
        text-align: left;
        line-height: 1.5em;
    }
    .talktext p{

        -webkit-margin-before: 0em;
        -webkit-margin-after: 0em;
        font-weight: 500;
    }

    /* End Help User */
   

    @media screen and (max-width: 800px) {
        #container {
            width: 100%;
        }
        .mailInput{
            width: 90%;
        }
        .error-show {
            left: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            z-index: 2;
        }
        .talk-bubble {
            width: 225px;
        }
    }

    @media screen and (max-width: 475px) {
        #container {
            height: 65vh;
        }
         .error-show {
            top: 32%;
        }
    }

     @media screen and (max-width: 375px) and (max-height: 680px) {
        #container{
            width: 100%;
            height: 75vh;
            padding: 40px;
            padding-top: 35px;
        }
        .error-show {
            top: 38%;
        }
    }

    @media screen and (max-width: 325px) and (max-height: 600px) {
        #container {
            width: 100%;
            height: 90vh;
        }
        .error-show {
            top: 38%;
        }
    }
</style>